import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';
import ExampleFrameButton from '../example-buttons/ExampleFrameButton.vue';

# Frames

A Frame is a representation of content, you can connect a Frame or Frames to a Channel (similar to a playlist). In CanvasPro we currently support up to 6 Frames

## Frame Options

### Default Frame Layout

When you first install CanvasPro available frames will be stacked up on the top left.

If you click **Frame 1** in the Canvas, you can move this to reveal **Frame 2** and so on.

You can also click on the <ExampleFrameButton name="FRAME 1" color="red"/> <ExampleFrameButton name="FRAME 2" color="purple"/> <ExampleFrameButton name="FRAME 3" color="green"/> etc Buttons to activate a Frame for configuring.

## Editing a frame

### Width and Height

If you click the frame you wish to edit it will display 4 handles, you can click and drag these handles to change the size of the Frame.

{/* Editor note: */}
{/* ~~You can also change the active frames Width and Height more accurately by typing in the required values.~~ */}

### Left and Top Offset

This is the position of the frame from the top left of the Canvas, you can manually move a frame to adjust this.

{/* Editor note: */}
{/* ~~or you can more accurately type in the position you require it to be.~~ */}

## Saving

Once you're happy with your changes you need to save them, if you're unhappy with them and want to keep things as they were. You can simply refresh the page to see your previous Canvas and Frame Settings.
